<template>
<section id="features" class="vpn-section features">
  <div class="vpn-section__inner">
    <h2 class="vpn-section__title">{{ sectionTitle }}</h2>
    <div class="features__grid">
      <article v-for="item in featureList" :key="item.title" class="features__card">
        <div class="features__copy">
          <div class="features__name">{{ item.title }}</div>
          <p>{{ item.desc }}</p>
        </div>
        <div class="features__media">
          <img :src="item.img" :alt="item.title" loading="lazy" width="258" height="351">
        </div>
      </article>
    </div>
  </div>
</section>
</template>

<script>
import img1 from '@/assets/vpn/feature-1.png'
import img2 from '@/assets/vpn/feature-2.png'
import img3 from '@/assets/vpn/feature-3.png'
import img4 from '@/assets/vpn/feature-4.png'
import img5 from '@/assets/vpn/feature-5.png'
import img6 from '@/assets/vpn/feature-6.png'
import img7 from '@/assets/vpn/feature-7.png'
import img8 from '@/assets/vpn/feature-8.png'

import homeLocaleContent from '@/mixins/homeLocaleContent';

export default {
  name: 'FeaturesSection',
  mixins: [homeLocaleContent],
  computed: {
    sectionTitle() {
      return this.homeLocale?.featuresTitle || 'What’s possible with Secure’s free VPN?';
    },
    featureList() {
      if (this.homeLocale?.featureCards?.length) {
        return this.homeLocale.featureCards;
      }
      return this.defaultFeatures;
    },
  },
  data() {
    return {
      defaultFeatures: [
        {
          title: 'Encrypted Online Security',
          desc: 'Protect your online activity with strong encryption to keep your personal data and internet traffic private.',
          img: img1,
        },
        {
          title: 'Fast Global Servers',
          desc: 'Connect to high-speed VPN servers around the world for smooth browsing, streaming, and everyday internet use.',
          img: img2,
        },
        {
          title: 'Multiple Server Locations',
          desc: 'Choose from servers in different countries to enjoy a stable connection wherever you are.',
          img: img3,
        },
        {
          title: 'One-Tap Connection',
          desc: 'Connect to the best available server instantly with a single tap—no complicated setup required.',
          img: img4,
        },
        {
          title: 'Servers Worldwide',
          desc: 'Connect to global VPN servers for fast, secure, and reliable browsing wherever you are, anytime you need.',
          img: img5,
        },
        {
          title: 'Smooth Streaming',
          desc: 'Enjoy fast and stable connections for videos, live streaming, and other online entertainment.',
          img: img6,
        },
        {
          title: 'High-Speed Performance',
          desc: 'Optimized servers deliver fast, stable connections for browsing, gaming.',
          img: img7,
        },
        {
          title: 'Free & Uncapped',
          desc: 'Enjoy unlimited VPN access with no daily data limits or hidden charges.',
          img: img8,
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/css/vpn-sections.scss';

.features {
  background: linear-gradient(180deg, #f7f5fc 0%, #efeafc 100%);

  .vpn-section__title {
    text-align: left;
  }
}

.features__grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 18px;
}

.features__card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 420px;
  border-radius: 22px;
  overflow: hidden;
  background:
    radial-gradient(120% 80% at 0% 100%, rgba(167, 139, 250, 0.22) 0%, transparent 55%),
    radial-gradient(110% 70% at 100% 100%, rgba(196, 181, 253, 0.18) 0%, transparent 50%),
    #ffffff;
  box-shadow: 0 1px 0 rgba(109, 74, 255, 0.04), 0 14px 36px rgba(70, 50, 140, 0.08);
  border: 1px solid rgba(214, 204, 245, 0.65);
}

.features__copy {
  padding: 28px 24px 12px;
  flex: 1;

  .features__name {
    margin: 0 0 10px;
    font-size: 15px;
    line-height: 1.3;
    letter-spacing: -0.01em;
    color: #6d4aff;
    font-weight: 700;
  }

  p {
    margin: 0;
    color: #495057;
    font-size: 14.5px;
    line-height: 1.55;
  }
}

.features__media {
  margin-top: auto;
  padding: 8px 16px 18px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  min-height: 180px;

  img {
    width: 100%;
    max-width: 220px;
    height: auto;
    display: block;
    object-fit: contain;
    border-radius: 16px;
    filter: drop-shadow(0 10px 18px rgba(80, 60, 140, 0.12));
  }
}

@media (max-width: 1100px) {
  .features__card {
    min-height: 380px;
  }

  .features__copy .features__name {
    font-size: 14px;
  }
}

@media (max-width: 1024px) {
  .features__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .features__copy .features__name {
    white-space: normal;
  }
}

@media (max-width: 560px) {
  .features__grid {
    grid-template-columns: 1fr;
  }

  .features__card {
    min-height: 0;
  }

  .features__copy {
    padding: 20px 16px 10px;

    .features__name {
      font-size: 15px;
    }

    p {
      font-size: 14px;
    }
  }

  .features__media {
    min-height: 140px;
    padding: 4px 12px 14px;

    img {
      max-width: 180px;
    }
  }
}
</style>
